export enum TelemetryWidgetTimeRange {
    Last10Minutes = 0,
    LastHour = 1,
    Last4Hours = 2,
    Last24Hours = 3,
    LastWeek = 4,
    LastMonth = 5,
    // Day is always disabled, we use it as separator
    Day = 6,
    Today = 7,
    Yesterday = 8,
    Monday = 9,
    Tuesday = 10,
    Wednesday = 11,
    Thursday = 12,
    Friday = 13,
    Saturday = 14,
    Sunday = 15,

    Last2Months = 16,
    LastQuarter = 17,
    LastHalfYear = 18,
    LastYear = 19,
}
